export const getProfit = (sale) => {
  return ((sale.ebayprice || 0) +
        (sale.shipping || 0) -
        (sale.ActualMyCost || 0) -
        (sale.ActualShipping || 0) -
        (sale.ebayfees || 0) -
        (sale.amazonfees || 0)).toFixed(2)
}

export const getTaxes = (sale) => {
    if (sale.country == 'US' && sale.state == 'TX') {
        if (sale.marketplace == 'eBay') {
            return (sale.ebaytaxes || 0).toFixed(2)
        } else {
            return (sale.ebayprice * 8.25 / 100).toFixed(2)
        }
    }
    return ''
}

export const getFees = (sale) => {
    if (sale.ebayfees > 0) {
        return (parseFloat(sale.ebayfees) || 0).toFixed(2)
    } else {
        return (parseFloat(sale.amazonfees) || 0).toFixed(2)
    }
}